import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { CategoryBannerApi } from '../../../lib/api/category/CategoryBannerApi';
import { CATEGORY } from '../../../constants/queryKeys';
import useToastMsg from '../../common/useToastMsg';
import categoryToastMsg from '../../../constants/service/toastMsg/categoryToastMsg';
import { extractErrorMessage, ErrorResponseType } from '../../../lib/utils/checkErrorResponse';
import { CategoryBannerResponse } from '../../../lib/api/category/categoryBannerType';

export const useDeleteCategoryBannerMutate = (
  onSuccessCallback?: () => void,
  // 빈 상태 저장(=DELETE 라우팅) 케이스에서 호출 측이 "저장 성공" 메시지로 통일하려고 덮어씀.
  successMessage: string = categoryToastMsg.DELETE_CATEGORY_BANNER_SUCCESS,
) => {
  const { id } = useParams<{ id: string }>();
  const categoryId = Number(id);
  const queryClient = useQueryClient();
  const { success, error } = useToastMsg();

  return useMutation({
    mutationFn: () => {
      if (Number.isNaN(categoryId)) {
        return Promise.reject(new Error('유효하지 않은 카테고리 ID입니다.'));
      }
      return CategoryBannerApi.deleteCategoryBanner(categoryId);
    },
    onSuccess: () => {
      queryClient.setQueryData<CategoryBannerResponse>([...CATEGORY.BANNER, id], []);
      success(successMessage);
      onSuccessCallback?.();
    },
    onError: (err: ErrorResponseType) => {
      error(extractErrorMessage(err));
    },
  });
};
